import { Card, CardContent, IconButton, Modal } from '@material-ui/core';
import { CloseIcon } from '@/components/Icons';
import { TaxEventForm } from '@/components/Forms';
import { useMemo } from 'react';
import { parseISO } from 'date-fns';
import { getNextTaxEventDate } from '@/constants/tax-event.constants';
import { TaxTypesEnum } from '@/components/Forms/TaxEventForm/types';
import useStyles from '../styles';
import { IEditTaxEventModalProps } from './types';

const EditTaxEventModal = ({
  open,
  onClose,
  onSubmit,
  initialValues,
}: IEditTaxEventModalProps): JSX.Element => {
  const classes = useStyles();

  const formInitialValues = useMemo(
    () => ({
      id: initialValues?.id,
      targetDate: initialValues?.targetDate
        ? parseISO(initialValues.targetDate)
        : getNextTaxEventDate(),
      amountUah: initialValues?.amountUah ?? 0,
      taxType: initialValues?.taxType ?? TaxTypesEnum.SingleTax,
    }),
    [
      initialValues?.amountUah,
      initialValues?.id,
      initialValues?.targetDate,
      initialValues?.taxType,
    ],
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modalWrap}
      disableEnforceFocus
      disableAutoFocus
    >
      <Card className={classes.smallModalCard}>
        <CardContent className={classes.modalCardContent}>
          <IconButton
            aria-label="delete"
            className={classes.closeIconWrap}
            size="small"
            onClick={onClose}
          >
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
          <TaxEventForm
            // onSubmit={async (data, helpers) => {
            //   console.log(data);
            // }}
            onSubmit={onSubmit ?? (() => Promise.resolve())}
            initialValues={formInitialValues}
          />
        </CardContent>
      </Card>
    </Modal>
  );
};

export default EditTaxEventModal;
